module.exports = __webpack_public_path__ + "static/media/levels_2_5.c67224e9.svg";